import axios from '../script/axiosAMS'
import xlsx from 'xlsx/xlsx'

const affiliatedDealerCode = '315134'
const businessNumber = '120-82-00052'

export default {
  getAffiliatedDealerCode () {
    return affiliatedDealerCode
  },
  getBusinessNumber () {
    return businessNumber
  },
  async sleepFor (interval, loopMax, condition) {
    let waitCount = 0
    while (!condition()) {
      await new Promise(resolve => setTimeout(resolve, interval))
      waitCount++
      if (waitCount > loopMax) {
        return false
      }
    }
    return true
  },
  getSession (resultCallback) {
    axios.requestWith({
      url: '/api/session',
      method: 'get',
      resultCallback: resultCallback
    })
  },
  getCommonCode (params, resultCallback) {
    axios.requestWith({
      url: '/api/code',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  setCommonCode () {
    // 소속
    if (sessionStorage.getItem('acList') == null || sessionStorage.getItem('acList') === '' || sessionStorage.getItem('acList') === '[]') {
      this.getCommonCode({ groupCode: 'AC' }, response => { sessionStorage.setItem('acList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 소속
    if (sessionStorage.getItem('afcList') == null || sessionStorage.getItem('afcList') === '' || sessionStorage.getItem('afcList') === '[]') {
      this.getCommonCode({ groupCode: 'AFC' }, response => { sessionStorage.setItem('afcList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 본부
    if (sessionStorage.getItem('ofcList') == null || sessionStorage.getItem('ofcList') === '' || sessionStorage.getItem('ofcList') === '[]') {
      this.getCommonCode({ groupCode: 'OFC' }, response => { sessionStorage.setItem('ofcList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 담당업무
    if (sessionStorage.getItem('rwkList') == null || sessionStorage.getItem('rwkList') === '' || sessionStorage.getItem('rwkList') === '[]') {
      this.getCommonCode({ groupCode: 'RWK' }, response => { sessionStorage.setItem('rwkList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 사업구분
    if (sessionStorage.getItem('prtList') == null || sessionStorage.getItem('prtList') === '' || sessionStorage.getItem('prtList') === '[]') {
      this.getCommonCode({ groupCode: 'PRT' }, response => { sessionStorage.setItem('prtList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 구축구분
    if (sessionStorage.getItem('sttList') == null || sessionStorage.getItem('sttList') === '' || sessionStorage.getItem('sttList') === '[]') {
      this.getCommonCode({ groupCode: 'STT' }, response => { sessionStorage.setItem('sttList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 모뎀 진행현황
    if (sessionStorage.getItem('prgList') == null || sessionStorage.getItem('prgList') === '' || sessionStorage.getItem('prgList') === '[]') {
      this.getCommonCode({ groupCode: 'PRG' }, response => { sessionStorage.setItem('prgList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 모뎀 현재상태
    if (sessionStorage.getItem('crsList') == null || sessionStorage.getItem('crsList') === '' || sessionStorage.getItem('crsList') === '[]') {
      this.getCommonCode({ groupCode: 'CRS' }, response => { sessionStorage.setItem('crsList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 음영품질개선 - 요청구분
    if (sessionStorage.getItem('srtList') == null || sessionStorage.getItem('srtList') === '' || sessionStorage.getItem('srtList') === '[]') {
      this.getCommonCode({ groupCode: 'SRT' }, response => { sessionStorage.setItem('srtList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 음영품질개선 - 문제점 및 현상
    if (sessionStorage.getItem('iscList') == null || sessionStorage.getItem('iscList') === '' || sessionStorage.getItem('iscList') === '[]') {
      this.getCommonCode({ groupCode: 'ISC' }, response => { sessionStorage.setItem('iscList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
    // 음영품질개선 - 처리사항
    if (sessionStorage.getItem('actList') == null || sessionStorage.getItem('actList') === '' || sessionStorage.getItem('actList') === '[]') {
      this.getCommonCode({ groupCode: 'ACT' }, response => { sessionStorage.setItem('actList', response.data.resultCode === 1 ? JSON.stringify(response.data.result.body) : '[]') })
    }
  },
  /**
   *
   * @param type - general, retry, contact
   * @param value
   */
  amsAlert (type, value) {
    if (type === 'retry') {
      alert(value + '\n잠시 후 다시 시도해주세요.')
    } else if (type === 'contact') {
      alert(value + '\n잠시 후 다시 시도해주세요.\n지속적으로 문제가 발생할 경우 관리자에게 문의해주세요.')
    } else {
      alert(value)
    }
  },
  checkChangedData (data, origin) {
    let result = {}
    Object.keys(data).forEach(key1 => {
      result[key1] = data[key1]
      Object.keys(origin).forEach(key2 => {
        if (key1 === key2 && data[key1] === origin[key2]) {
          delete result[key1]
        }
      })
    })
    return result
  },
  getOnlyNumber (value) {
    return value != null ? value.toString().replace(/[^0-9]/g, '') : ''
  },
  getDatepickerLocal () {
    return {
      dow: 0,
      hourTip: '시간 선택',
      minuteTip: '분 선택',
      secondTip: '초 선택',
      yearSuffix: '년',
      monthsHead: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
      months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
      weeks: '일_월_화_수_목_금_토'.split('_'),
      cancelTip: '취소',
      submitTip: '선택'
    }
  },
  getFormattedDate (date) {
    if (date == null) return ''
    let _date = new Date(date)
    return _date.getFullYear() + '-' + ((_date.getMonth() + 1) < 10 ? '0' + (_date.getMonth() + 1) : (_date.getMonth() + 1)) + '-' + (_date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate())
  },
  checkValidateData (type, value) {
    if (value != null) {
      if (type === 'session') {
        return (value !== 'null' && value.length > 0) || (value !== '[]' && value.length > 0)
      } else if (type === 'string') {
        return value !== '' && value.length > 0
      } else if (type === 'number') {
        return typeof value === 'number'
      } else if (type === 'date') {
        return typeof value === 'object'
      } else if (type === 'email') {
        let regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
        return regex.test(value)
      } else {
        return false
      }
    } else {
      return false
    }
  },
  checkValidateLength (type, value, length) {
    if (type === 'min') {
      if (typeof value === 'string') {
        return value.length >= length
      } else if (typeof value === 'number') {
        return value >= length
      } else {
        return false
      }
    } else if (type === 'max') {
      if (typeof value === 'string') {
        return value.length <= length
      } else if (typeof value === 'number') {
        return value <= length
      } else {
        return false
      }
    } else if (type === 'minmax' && typeof length === 'object' && length.length === 2) {
      if (typeof value === 'string') {
        return value.length >= length[0] && value.length <= length[1]
      } else if (typeof value === 'number') {
        return value >= length[0] && value <= length[1]
      } else {
        return false
      }
    } else if (type === 'equal') {
      if (typeof value === 'string') {
        return value.length === length
      } else if (typeof value === 'number') {
        return value === length
      } else {
        return false
      }
    } else {
      return false
    }
  },
  getDaumAddressData (data) {
    let roadAddr = data.roadAddress
    let extraRoadAddr = ''
    if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
      extraRoadAddr += data.bname
    }
    if (data.buildingName !== '' && data.apartment === 'Y') {
      extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName)
    }
    if (extraRoadAddr !== '') {
      extraRoadAddr = ' (' + extraRoadAddr + ')'
    }
    return {
      postalCode: data.zonecode,
      addressRoad: roadAddr + extraRoadAddr,
      addressLot: data.jibunAddress
    }
  },
  fileDownload (url) {
    let browserName
    let userAgent = navigator.userAgent
    switch (true) {
      case /Trident|MSIE/.test(userAgent):
        browserName = 'ie'
        break
      case /Edge/.test(userAgent):
        browserName = 'edge'
        break
      case /Chrome/.test(userAgent):
        browserName = 'chrome'
        break
      case /Safari/.test(userAgent):
        browserName = 'safari'
        break
      case /Firefox/.test(userAgent):
        browserName = 'firefox'
        break
      case /Opera/.test(userAgent):
        browserName = 'opera'
        break
      default:
        browserName = 'unknown'
    } // ie 브라우저 및 EDGE 브라우저
    if (browserName === 'ie' || browserName === 'edge') { // ie11
      let _window = window.open(url, '_blank')
      _window.document.close()
      _window.document.execCommand('SaveAs', true, 'file.hwp' || url)
      _window.close()
    } else { // chrome
      let filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0]
      let xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function () {
        let a = document.createElement('a')
        a.href = window.URL.createObjectURL(xhr.response) // xhr.response is a blob
        a.download = filename // Set the file name.
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
      }
      // xhr.onreadystatechange = () => {
      //   if (xhr.readyState === 4) {
      //     if ((xhr.status === 200) || (xhr.status === 0)) {
      //       let a = document.createElement('a')
      //       a.href = window.URL.createObjectURL(xhr.response) // xhr.response is a blob
      //       let attr = document.createAttribute('download')
      //       a.setAttributeNode(attr)
      //       a.download = filename
      //       a.style.display = 'none'
      //       document.body.appendChild(a)
      //       a.click()
      //       a.remove()
      //     } else {
      //       alert('Sorry. Cannot find file.')
      //     }
      //   }
      // }
      xhr.open('GET', url)
      xhr.setRequestHeader('authorization', sessionStorage.accessToken)
      xhr.send()
    }
  },
  getUserRoleList () {
    return [
      {
        codePid: 1,
        codeValue: 1,
        codeName: '시스템 관리자'
      },
      {
        codePid: 2,
        codeValue: 2,
        codeName: '한전 담당자'
      },
      {
        codePid: 3,
        codeValue: 3,
        codeName: '자회사 담당자'
      },
      {
        codePid: 4,
        codeValue: 4,
        codeName: 'A/S 담당자'
      }
    ]
  },
  useStateList () {
    return [
      {
        codePid: 0,
        codeValue: 0,
        codeName: '신청'
      },
      {
        codePid: 1,
        codeValue: 1,
        codeName: '승인'
      },
      {
        codePid: 2,
        codeValue: 2,
        codeName: '거절'
      },
      {
        codePid: 3,
        codeValue: 3,
        codeName: '이용정지'
      }
    ]
  },
  canRequestFlagList () {
    return [
      {
        codePid: 1,
        codeValue: 1,
        codeName: '가능'
      },
      {
        codePid: 2,
        codeValue: 2,
        codeName: '소속(본부)이 다름'
      },
      {
        codePid: 3,
        codeValue: 3,
        codeName: '사용(혹은 정지) 상태가 아님'
      },
      {
        codePid: 4,
        codeValue: 4,
        codeName: '다른 요청이 있음(A/S 중복)'
      }
    ]
  },
  getEmailDomainList () {
    return [
      {
        codePid: 0,
        codeValue: 'kepco.co.kr',
        codeName: 'kepco.co.kr'
      },
      {
        codePid: 1,
        codeValue: 'naver.com',
        codeName: 'naver.com'
      },
      {
        codePid: 2,
        codeValue: 'hanmail.net',
        codeName: 'hanmail.net'
      },
      {
        codePid: 3,
        codeValue: 'gmail.com',
        codeName: 'gmail.com'
      },
      {
        codePid: 4,
        codeValue: 'gaias.com',
        codeName: 'gaias.com'
      },
      {
        codePid: 5,
        codeValue: 'lguplus.co.kr',
        codeName: 'lguplus.co.kr'
      }
    ]
  },
  getSQSignalLevelList () {
    return [
      {
        codePid: 1,
        codeValue: -89,
        codeName: '-90 미만'
      },
      {
        codePid: 2,
        codeValue: -90,
        codeName: '-90'
      },
      {
        codePid: 3,
        codeValue: -92,
        codeName: '-92'
      },
      {
        codePid: 4,
        codeValue: -94,
        codeName: '-94'
      },
      {
        codePid: 5,
        codeValue: -96,
        codeName: '-96'
      },
      {
        codePid: 6,
        codeValue: -98,
        codeName: '-98'
      },
      {
        codePid: 7,
        codeValue: -100,
        codeName: '-100'
      },
      {
        codePid: 8,
        codeValue: -102,
        codeName: '-102'
      },
      {
        codePid: 9,
        codeValue: -104,
        codeName: '-104'
      },
      {
        codePid: 10,
        codeValue: -106,
        codeName: '-106'
      },
      {
        codePid: 11,
        codeValue: -108,
        codeName: '-108'
      },
      {
        codePid: 12,
        codeValue: -109,
        codeName: '-108 초과'
      }
    ]
  },
  getRoleName (type) {
    const typeMessages = {
      1: '시스템 관리자',
      2: '한전 담당자',
      3: '자회사 담당자',
      4: 'A/S 담당자'
    }
    return typeMessages[type] || ''
  },
  getActionMsg (type) {
    const typeMessages = {
      'add': '등록',
      'edit': '수정',
      'delete': '삭제',
      'reqToAcc': '요청완료',
      'accToProc': '접수완료',
      'procToFin': '처리완료',
      'finConfirm': '처리확인'
    }
    return typeMessages[type] || ''
  },
  checkUserRole (mySession, validRole, action) {
    if (validRole == null || validRole < 1 || validRole > 4 || action == null || action.length <= 0) {
      this.amsAlert('general', '잘못된 요청입니다.')
      return {code: false}
    }
    if (mySession.userRole !== validRole) {
      this.amsAlert('general', this.getRoleName(validRole) + '만 ' + this.getActionMsg(action) + '할 수 있습니다.')
      return {code: false}
    }
    return {code: true}
  },
  checkUserRoleAndList (mySession, validRole, selectedList, action, type) {
    const resultUserRole = this.checkUserRole(mySession, validRole, action)
    if (!resultUserRole.code) {
      return {code: false}
    }
    if (selectedList.length <= 0) {
      this.amsAlert('general', this.getActionMsg(action) + '할 모뎀을 선택하세요.')
      return {code: false}
    }
    let list = []
    // let isMyRequest = true
    let isRequestIssue = true
    let isProcessDesc = true
    let isCanRequest = true
    for (let i = 0; i < selectedList.length; i++) {
      // if (type !== 'MODEM') {
      //   isMyRequest = selectedList[i].userPid === mySession.userPid
      // }
      if (isCanRequest && selectedList[i].canRequestFlag !== 1) {
        isCanRequest = false
      }
      if (type === 'MODEM') {
        list.push(selectedList[i].modemPid)
      } else if (type === 'AS') {
        if (isRequestIssue && (selectedList[i].requestIssue == null || selectedList[i].requestIssue.length <= 0)) {
          isRequestIssue = false
        }
        if (isProcessDesc && (selectedList[i].asDesc == null || selectedList[i].asDesc.length <= 0)) {
          isProcessDesc = false
        }
        list.push(selectedList[i].asPid)
      } else if (type === 'SQ') {
        if (isRequestIssue && (selectedList[i].meterNum == null || selectedList[i].meterNum.length <= 0)) {
          isRequestIssue = false
        }
        if (isProcessDesc && (selectedList[i].action == null || selectedList[i].action.length <= 0)) {
          isProcessDesc = false
        }
        list.push(selectedList[i].sqPid)
      } else if (type === 'STOP') {
        if (action === 'reqToAcc' || action === 'delete') {
          list.push(selectedList[i].stopPid)
        } else {
          list.push(selectedList[i].stopGroupPid)
        }
      } else if (type === 'CANCEL') {
        if (action === 'reqToAcc' || action === 'delete') {
          list.push(selectedList[i].csPid)
        } else {
          list.push(selectedList[i].csGroupPid)
        }
      }
    }
    // if ((action === 'reqToAcc' || action === 'edit' || action === 'delete') && !isMyRequest) {
    //   this.amsAlert('general', '자신이 등록한 모뎀만 ' + this.getActionMsg(action) + '할 수 있습니다.')
    //   return {code: false}
    // }
    if (action === 'reqToAcc' && !isCanRequest) {
      this.amsAlert('general', '요청 불가능한 모뎀이 포함되어 있습니다.')
      return {code: false}
    }
    if (action === 'reqToAcc' && !isRequestIssue) {
      this.amsAlert('general', (selectedList.length > 1 ? '요청사항을 등록하지 않은 모뎀이 포함되어 있습니다.\n' : '') + '요청사항을 등록하세요.')
      return {code: false}
    }
    if (action === 'procToFin' && !isProcessDesc) {
      this.amsAlert('general', (selectedList.length > 1 ? '처리사항을 등록하지 않은 모뎀이 포함되어 있습니다.\n' : '') + '처리사항을 등록하세요.')
      return {code: false}
    }
    return {code: true, list: list}
  },
  getOriginalFileName (value) {
    if (!this.checkValidateData('string', value)) {
      this.amsAlert('retry', '파일명이 읽을 수 없습니다.')
      return null
    }
    let fileNameArray = []
    for (let i = 0; i < value.split('_').length - 1; i++) {
      fileNameArray.push(value.split('_')[i])
    }
    return fileNameArray.join('_') + '.' + value.split('.')[value.split('.').length - 1]
  },
  openManualNewWindow (type) {
    if (type == null || type.length <= 0) {
      this.amsAlert('general', '잘못된 접근입니다.')
    }
    // let path = 'http://localhost:8081/#/Manual/' + type // TODO: Only Local Development
    // let path = 'http://61.42.1.48:8080/Manual/' + type // TODO: Only Development Server
    let path = 'https://kepcoams.com/Manual/' + type // TODO: Only Production Server
    window.open(path, '_blank', 'width=1000,height=700')
  },
  readExcel (e, type) {
    function isValidValue (value) {
      return value != null && value.length > 0
    }
    function checkRequirement (type, obj) {
      console.log('checkRequirement', obj)
      switch (type) {
        case 'MODEM': // 모뎀현황
          return (
            isValidValue(obj.registryNum) && // 가입번호
            isValidValue(obj.usim) && // USIM
            isValidValue(obj.projectType) && // 사업구분
            isValidValue(obj.structType) // 구축구분
          )
        case 'ASP': // 모뎀AS처리
          return (
            isValidValue(obj.registryNum) && // 가입번호
            isValidValue(obj.asDesc) // 처리내용
          )
        case 'SQR': // 음영품질개선 요청
          return (
            isValidValue(obj.registryNum) && // 가입번호
            isValidValue(obj.meterNum) && // 기기번호(계량기 번호)
            isValidValue(obj.requestType) && // 요청구분
            isValidValue(obj.siteMngName) && // 현장담당자(이름)
            isValidValue(obj.siteMngContract) && // 현장담당자 연락처
            (
              isValidValue(obj.postalCode) || // 우편번호
              isValidValue(obj.addressRoad) || // 도로명주소
              isValidValue(obj.addressLot) || // 지번주소
              isValidValue(obj.addressDetails) // 상세주소
            ) && // 주소는 4개 항목이 모두 없을 경우에만 실패
            isValidValue(obj.buildingName) && // 상호/건물명
            isValidValue(obj.modemPos) && // 모뎀위치
            isValidValue(obj.meterPos) // 계량기 상세 위치
          )
        case 'SQP': // 음영품질개선 처리
          return (
            isValidValue(obj.registryNum) && // 가입번호
            isValidValue(obj.procDate) && // 처리날짜
            isValidValue(obj.action) // 조치내역
          )
        default:
          return false
      }
    }
    function removeNullItems (data) {
      // 주어진 리스트를 복제하여 새로운 리스트를 생성합니다.
      // 이를 통해 원본 데이터를 변경하지 않고 새로운 리스트에만 작업을 수행합니다.
      let newData = data.map(item => {
        // 각 객체의 키와 값에 대해 반복문을 수행합니다.
        // 값이 null이 아닌 경우에만 새로운 객체에 해당 키와 값을 추가합니다.
        let newItem = {}
        for (let key in item) {
          if (item[key] !== null) {
            newItem[key] = item[key]
          }
        }
        return newItem
      })
      return newData
    }
    return new Promise((resolve, reject) => {
      if (e.target.files.length === 0) {
        reject(new Error('엑셀 파일을 등록하세요'))
      }
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = xlsx.read(data, {type: 'array'})
        const sheetName = workbook.SheetNames[0]
        const sheetData = xlsx.utils.sheet_to_json(workbook.Sheets[sheetName], { raw: false, defval: null })
        let result = 1
        const valueMap = new Map()
        let list = []
        for (let i = 0; i < sheetData.length; i++) {
          if (i !== 0) {
            list.push(sheetData[i])
          }
        }
        for (const obj of list) {
          if (obj.mobileNum == null) {
            result = 2
          } else {
            const value = obj['mobileNum'].replace(/\D/g, '')
            if (valueMap.has(value)) {
              result = 3
            } else {
              if (type === 'MODEM' || type === 'ASP' || type === 'SQR' || type === 'SQP') {
                if (!checkRequirement(type, obj)) {
                  result = 2
                } else {
                  valueMap.set(value, true)
                }
              }
            }
          }
        }
        if (result === 1) { // 중복 없음
          resolve(removeNullItems(list))
        } else if (result === 2) {
          reject(new Error('필수 데이터를 찾지 못했습니다.\n매뉴얼을 확인하고 엑셀 등록 템플릿을 다운로드해서 사용하세요.'))
        } else if (result === 3) {
          reject(new Error('휴대전화번호가 중복되었습니다.'))
        } else {
          reject(new Error('엑셀 일괄 등록을 하지 못했습니다.'))
        }
        reader.onerror = (e) => {
          reject(e.target.error)
        }
      }
      reader.readAsArrayBuffer(file)
    })
  },
  detectMobileBrowser () {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined' && /Mobi|Android/i.test(navigator.userAgent)
  },
  numberWithComma (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}



// WEBPACK FOOTER //
// ./src/script/common.js